import { Injectable } from "@angular/core";
import { SpinnerComponent } from "../../../shell/spinner/spinner.component";

const spinnerShowTimeout: number = 50; // x100ms

@Injectable()
export class SpinnerService {  
    private spinner: SpinnerComponent;
    private showCount: number = 0;
    private timer;
    private ticks: number = 0;
    private timerCounting: boolean = false;

    _register(spinner: SpinnerComponent) {
        this.spinner = spinner;
    }

    public show() {
        if(this.spinner) {
            this.showCount++;
            if(this.showCount > 0) {
                this.spinner.show = true;
                this.ticks = spinnerShowTimeout;

                if(!this.timerCounting) {
                    this.startTimer();
                }
            }
        }
    }

    public hide() {
        if(this.spinner) {
            if(this.showCount > 0) {
                this.showCount--;
            }
            if(this.showCount <= 0) {
                this.spinner.show = false;
                this.showCount = 0;
                this.ticks = 0;
                this.stopTimer();
            }
        }
    }

    private startTimer() {
        this.timerCounting = true;
        this.timer = setInterval(() => {
            if(this.timerCounting) {
                this.ticks--;
            }
            if(this.ticks <= 0) {
                this.spinner.show = false;
                this.showCount = 0;
                this.stopTimer();
            }
        }, 100);
    }

    private stopTimer() {
        this.timerCounting = false;
        if(this.timer) {
            clearInterval(this.timer);
        }
    }
}